import { onTurboPageLoad } from "../turboHelper";
import { getModel } from "../modelHelper";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import { attachSummernote } from "../summernoteHelper";

onTurboPageLoad("Destinations/BasicInfo", () => {
    const model = getModel<IDestinationBasicInfoModel>();

    const form = $("#setBasicInfoForm");
    const editorInputs = $(".html-editor");
    attachSummernote(editorInputs);

    formSubmitWithWaitForJobCompletion(
        form,
        $("#submit"),
        model.getJobUrl,
        () => {
            history.back();
        }
    );
});

interface IDestinationBasicInfoModel {
    getJobUrl: string;
}
